import React, { createContext, useState, FC } from 'react';

export type ErrorContextType = {
  hasError: boolean;
  updateError: (value: boolean) => void;
};

const ErrorContext = createContext<ErrorContextType>({
  hasError: false,
  updateError: () => {},
});

const ErrorContextProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [hasError, setHasError] = useState(false);

  const updateError = (value: boolean) => {
    setHasError(value);
  };

  return (
    <ErrorContext.Provider value={{ hasError, updateError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export { ErrorContext, ErrorContextProvider };
